module.exports = __webpack_public_path__ + "static/media/lv2-1.54a034fc.mp3";